import { Typography } from '@mui/material';
import { Check24Icon, CompanyLogo, Spinner } from '@truvhq/ui';

type DropdownCompany = {
  id: string;
  name: string;
  logo_url?: string;
  value: string;
};

export const TenantCompaniesItem = ({
  company,
  isSelected,
  isLoading,
}: {
  company: DropdownCompany;
  isSelected: boolean;
  isLoading: boolean;
}) => {
  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex items-center">
        <CompanyLogo borderRadius={10} logoUrl={company.logo_url} name={company.name} />
        <div className="flex w-[330px] flex-col">
          <Typography noWrap variant="body2">
            {company.name}
          </Typography>
          <div className="flex flex-row">
            <Typography noWrap className="text-grey60" variant="body2">
              {company.value}
            </Typography>
          </div>
        </div>
      </div>
      {isLoading && isSelected ? (
        <Spinner size={20} />
      ) : isSelected ? (
        <Check24Icon className="h-5 w-5 text-primary-main" data-testid="tenantCompanyItem-check" />
      ) : null}
    </div>
  );
};
